import { z } from "zod";
import { supabase } from "@/lib/supabase";
import type { ProfileTeamScope } from "@/types/users";

const distributionCountsSchema = z.record(z.string(), z.number());

const reportsDistributionsSchema = z.object({
  siteTypes: distributionCountsSchema,
  geo: distributionCountsSchema,
  keywords: distributionCountsSchema,
  languages: distributionCountsSchema,
});

export type ReportsDistributionsResponse = z.infer<
  typeof reportsDistributionsSchema
>;

class ReportsService {
  private static instance: ReportsService;

  private constructor() {}

  public static getInstance(): ReportsService {
    if (!ReportsService.instance) {
      ReportsService.instance = new ReportsService();
    }
    return ReportsService.instance;
  }

  public async fetchAllReportStats(
    profile: ProfileTeamScope | null | undefined,
  ): Promise<ReportsDistributionsResponse> {
    const { data, error } = await supabase.rpc("get_reports_distributions", {
      p_team:
        profile?.role === "admin" ? undefined : (profile?.team ?? undefined),
    });

    if (error) throw error;

    return reportsDistributionsSchema.parse(data);
  }
}

export const reportsService = ReportsService.getInstance();
